export const USER_GET_REQUEST = "USER_GET_REQUEST";
export const USER_GET_SUCCESS = "USER_GET_SUCCESS";
export const USER_GET_ERROR = "USER_GET_ERROR";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_ERROR = "USER_REGISTER_ERROR";

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_ERROR = "USER_LOGIN_ERROR";

export const USER_LOGOUT_REQUEST = "USER_LOGOUT_REQUEST";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_ERROR = "USER_LOGOUT_ERROR";

export const USER_AUTH_REQUEST = "USER_AUTH_REQUEST";
export const USER_AUTH_SUCCESS = "USER_AUTH_SUCCESS";
export const USER_AUTH_ERROR = "USER_AUTH_ERROR";

export const USER_PROFILE_REQUEST = "USER_PROFILE_REQUEST";
export const USER_PROFILE_REQUEST_SUCCESS = "USER_PROFILE_REQUEST_SUCCESS";
export const USER_PROFILE_REQUEST_ERROR = "USER_PROFILE_REQUEST_ERROR";

export const USER_PROFILE_UPDATE_REQUEST = "USER_PROFILE_UPDATE_REQUEST";
export const USER_PROFILE_UPDATE_SUCCESS = "USER_PROFILE_UPDATE_SUCCESS";
export const USER_PROFILE_UPDATE_ERROR = "USER_PROFILE_UPDATE_ERROR";

export const USER_PASSWORD_UPDATE_REQUEST = "USER_PASSWORD_UPDATE_REQUEST";
export const USER_PASSWORD_UPDATE_SUCCESS = "USER_PASSWORD_UPDATE_SUCCESS";
export const USER_PASSWORD_UPDATE_ERROR = "USER_PROFILE_UPDATE_ERROR";

export const USER_FORGET_PASSWORD_UPDATE_REQUEST = "USER_FORGET_PASSWORD_UPDATE_REQUEST";
export const USER_FORGET_PASSWORD_UPDATE_SUCCESS = "USER_FORGET_PASSWORD_UPDATE_SUCCESS";
export const USER_FORGET_PASSWORD_UPDATE_ERROR = "USER_FORGET_PROFILE_UPDATE_ERROR";

export const USER_SUBSCRIBE_REQUEST = "USER_SUBSCRIBE_REQUEST";
export const USER_SUBSCRIBE_SUCCESS = "USER_SUBSCRIBE_SUCCESS";
export const USER_SUBSCRIBE_ERROR = "USER_SUBSCRIBE_ERROR";